import React from 'react';
import {Button, Tooltip} from "@mantine/core";
import {IconChevronsLeft} from "@tabler/icons-react";
import {useNavigate} from "react-router-dom";

/**
 * A small button that navigates back to the previous page or to a specified URL, shown with a chevron icon and a tooltip.
 */
const BackToListButton = ({ specificUrl = null }:{ specificUrl?: string | null }) => {
    const navigate = useNavigate();

    const handleClose = () => {
        if (specificUrl) navigate(specificUrl)
        else navigate(-1);
    };

    return (
        <Tooltip label={"Back to List"}>
            <Button
                variant="default"
                style={{ marginRight: 8 }}
                onClick={handleClose}
            >
                <IconChevronsLeft />
            </Button>
        </Tooltip>
    );
};

export default BackToListButton;
